import React from "react";
import UnifiedProfile from "../../component/UnifiedProfile";

const AdminProfile = () => {
    return <UnifiedProfile role="admin" />;
};

export default AdminProfile;
